import React from 'react';
export function useCadencedTime(memo) {
    var getMemoValue = React.useCallback(function () { return memo(Date.now()); }, [memo]);
    var _a = React.useState(getMemoValue), value = _a[0], setValue = _a[1];
    var requestRef = React.useRef();
    React.useEffect(function () {
        cancelAnimationFrame(requestRef.current);
        var enable = true;
        // handle time between setValue() and next render
        var tempValue = value;
        var update = function () {
            if (!enable) {
                return;
            }
            var memoNow = getMemoValue();
            if (memoNow !== tempValue) {
                tempValue = memoNow;
                setValue(memoNow);
            }
            requestRef.current = requestAnimationFrame(update);
        };
        requestRef.current = requestAnimationFrame(update);
        return function () {
            enable = false;
            cancelAnimationFrame(requestRef.current);
        };
    }, [getMemoValue, value]);
    return value;
}
